import { create } from 'zustand';

export type PreviewDevice = 'phone' | 'tablet' | 'both';
export type PreviewOrientation = 'portrait' | 'landscape';

interface PreviewState {
  device: PreviewDevice;
  orientation: PreviewOrientation;
  refreshKey: number;
  /** Inspect (false, default) = tap selects sections/blocks.
   *  Interact (true) = preview is live, taps navigate (Shopify-style). */
  interactive: boolean;
  /** Collection/product handle the preview iframe should render, decoupled
   *  from the editor template. The merchant edits the generic `collection`
   *  template while the preview shows a specific collection (Shopify model).
   *  null = render the template's own/default resource. */
  previewHandle: string | null;
  setDevice: (device: PreviewDevice) => void;
  setOrientation: (orientation: PreviewOrientation) => void;
  refresh: () => void;
  setInteractive: (interactive: boolean) => void;
  setPreviewHandle: (handle: string | null) => void;
}

export const usePreviewStore = create<PreviewState>((set) => ({
  device: 'phone',
  orientation: 'portrait',
  refreshKey: 0,
  interactive: false,
  previewHandle: null,
  setDevice: (device) => set({ device }),
  setOrientation: (orientation) => set({ orientation }),
  refresh: () => set((s) => ({ refreshKey: s.refreshKey + 1 })),
  setInteractive: (interactive) => set({ interactive }),
  setPreviewHandle: (previewHandle) => set({ previewHandle }),
}));
